import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-user-change-password',
  templateUrl: './user-change-password.component.html'
})
export class UserChangePasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  submitted = false;
  loading = false;
  userId: number;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService
    ) {
    this.userId = +this.route.snapshot.params.userId;
    this.route.params.subscribe(params => {
      this.userId = +params.userId;
    });
  }

  ngOnInit() {
    this.buildForm();
  }

  private buildForm() {
    this.changePasswordForm = this.formBuilder.group({
      password: new FormControl(null, Validators.required),
      passwordConfirm: new FormControl(null, [Validators.required, this.confirmPasswordValidator.bind(this)]),
    });
  }

  get f() { return this.changePasswordForm.controls; }

  confirmPasswordValidator(control: FormControl): {[s: string]: boolean} {
    if (!!this.changePasswordForm && (control.value !== this.changePasswordForm.value.password)) {
      return {confirmPasswordIsInvalid: true};
    }
    return null;
  }

  onSubmit() {
    this.submitted = true;

    if (this.changePasswordForm.invalid) {
      return;
    }

    this.loading = true;

    this.userService.changeUserPassword(this.userId, {password: this.changePasswordForm.value.password})
      .subscribe(res => {
        this.loading = false;
      });
  }
}
